import { queryOptions } from '@tanstack/react-query'
import { getEdition } from 'Edition/api/EditionApi'

import { RequestStaleTime } from 'Common/utils/helpers/HelperQuery'

export const editionQueries = {
    all: () => ['editions'],
    details: () => [...editionQueries.all(), 'detail'],
    detail: (id: number) =>
        queryOptions({
            queryKey: [...editionQueries.details(), id],
            queryFn: () => getEdition(id),
            staleTime: RequestStaleTime.default,
        }),
}
